import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    number: 'BONUS 1',
    title: 'Il Dizionario dei Feedback',
    desc: 'Le frasi precise per correggere i difetti tecnici istantaneamente e suonare come un esperto.',
    image: 'https://cdn.magicpatterns.com/uploads/2tbj39GP5t9ZLaGZUiGvPJ/b7ed9c34-0703-4f4b-9240-29fc80b0b910-mockup.webp'
  }, {
    number: 'BONUS 2',
    title: 'Kit "Prima Gara Perfetta"',
    desc: 'Protocolli per gestire il riscaldamento pre-partita e i time-out senza stress.',
    image: 'https://cdn.magicpatterns.com/uploads/2tU8dYcBS1TeUcpjgzqYMc/551f0643-2389-4071-8932-474c62a8247c-mockup.webp'
  }, {
    number: 'BONUS 3',
    title: 'Video Analisi fai-da-te',
    desc: 'Guida per usare lo smartphone per analizzare la tecnica senza software costosi.',
    image: 'https://cdn.magicpatterns.com/uploads/dsp5fu5scCPMUKaaupvZYP/142a9574-ba05-4b92-a9bc-26b62f2eb637-mockup.webp'
  }, {
    number: 'BONUS 4',
    title: 'Playlist "Energia in Palestra"',
    desc: 'Musica selezionata per mantenere alto il ritmo e la motivazione.',
    image: 'https://cdn.magicpatterns.com/uploads/cZYsvjFrQijqMFJDpQHfND/e918a399-c06f-4f02-a94c-570422293180-mockup.webp'
  }, {
    number: 'BONUS 5',
    title: 'Protocollo Comunicazione Genitori',
    desc: "Modelli pronti all'uso per gestire il rapporto con le famiglie in modo professionale.",
    image: 'https://cdn.magicpatterns.com/uploads/kKgBkFHP4zGf7F8cBb6J3Y/94784d3d-8d36-4e03-a6ac-2947d2668f17-mockup.webp'
  }];
  return <section className="bg-white py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-27">
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-volley-orange/5 rounded-full blur-3xl pointer-events-none" data-id="element-28"></div>
      <div className="absolute bottom-20 left-0 w-[500px] h-[500px] bg-volley-teal/5 rounded-full blur-3xl pointer-events-none" data-id="element-29"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-30">
        <div className="text-center mb-16" data-id="element-31">
          <div className="bg-volley-orange/10 text-volley-orange-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em] flex items-center gap-2 w-fit mx-auto" data-id="element-32">
            <Gift className="w-4 h-4" data-id="element-33" /> 5 BONUS DI LUSSO INCLUSI
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight mb-4 tracking-tight" data-id="element-34">
            Riceverai inoltre{' '}
            <span className="italic text-volley-orange" data-id="element-35">
              5 risorse esclusive
            </span>{' '}
            gratuitamente
          </h2>
          <p className="text-volley-slate text-lg max-w-2xl mx-auto" data-id="element-36">
            Strumenti che trasformeranno il tuo lavoro quotidiano — inclusi
            GRATIS nel tuo pacchetto.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-37">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-volley-paper rounded-3xl p-6 shadow-sm border border-volley-navy/5 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-38">
              <div className="relative mb-6 overflow-hidden rounded-2xl bg-volley-soft aspect-square border border-black/5" data-id="element-39">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="400" height="400" data-id="element-40" />
                <div className="absolute top-4 left-4 bg-volley-orange text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide shadow-md" data-id="element-41">
                  {bonus.number}
                </div>
                <div className="absolute top-4 right-4 bg-volley-teal text-white text-[10px] font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow-md" data-id="element-42">
                  🎁 Gratis
                </div>
              </div>
              <h3 className="font-display font-semibold text-volley-navy text-xl leading-tight mb-3" data-id="element-43">
                {bonus.title}
              </h3>
              <p className="text-volley-slate text-base leading-relaxed" data-id="element-44">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-gradient-to-br from-volley-navy to-volley-navy-dark rounded-3xl p-8 shadow-xl flex flex-col items-center justify-center text-center text-white relative overflow-hidden" data-id="element-45">
            <div className="absolute inset-0 bg-volley-teal/20 blur-2xl transform scale-150" data-id="element-46"></div>
            <div className="relative z-10 flex flex-col items-center" data-id="element-47">
              <Gift className="w-12 h-12 text-volley-orange mb-4" data-id="element-48" />
              <p className="text-white/80 text-sm uppercase tracking-wider mb-2 font-medium" data-id="element-49">
                Tutto incluso nel
              </p>
              <p className="font-display text-3xl sm:text-4xl font-semibold text-white mb-3" data-id="element-50">
                Pacchetto 6-in-1
              </p>
              <p className="text-white/80 text-base leading-relaxed" data-id="element-51">
                I 5 bonus sono GRATIS con il tuo acquisto oggi.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}